<template>
  <div class="block-text">
        {{ text }}
  </div>
</template>

<script>
export default {
    name: 'WkBlockText',
    props: {
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.block-text {
    padding: 20px;
    border: 1px solid #ccc;
    background: #cce6ff;
    display: flex;
    align-items: center;
    color: #666;
}
</style>